// grades wont store in sorted order in db, so this function will display grades nicely to users
export function sortGrades(str) {
  let arr = str.split(',')
  let index = arr.findIndex((i) => i === 'K')
  if (index !== -1) {
    arr.splice(index,1)
    arr.sort()
    arr.unshift('K')
  } else {
    arr.sort()
  }
  return arr.join(',')
}

// enrollment page helper to only get the notes for student's grade level
export function getGradeLevelNotes(semester, grade) {
  switch(grade) {
    case 'K':
      return semester.kindergarten
      break
    case '1':
      return semester.grade_1
      break
    case '2':
      return semester.grade_2
      break
    case '3':
      return semester.grade_3
      break
    case '4':
      return semester.grade_4
      break
    case '5':
      return semester.grade_5
      break
    case '6':
      return semester.grade_6
      break
    case '7':
      return semester.grade_7
      break
    case '8':
      return semester.grade_8
      break
    case '9':
      return semester.grade_9
      break
    case '10':
      return semester.grade_10
      break
    case '11':
      return semester.grade_11
      break
    case '12':
      return semester.grade_12
  }
}
